module.exports = __webpack_public_path__ + "img/trash.157037f6.svg";